export interface SpacerProps {
  height: number | string
}

export const Spacer = ({ height }: SpacerProps) => {
  return <div style={{ width: '100%', height }} />
}
